// roster-identity.js -- #1366 / #1382 (spec 2026-10-07 §6, r2 strict-first).
// Single job: map a bet leg's player name to ONE roster player_id -- strict-first, with a lenient
// (betting.js matchPlayer) fallback only when the strict rule finds no id at all.
// Reads: its arguments. Writes: nothing. Does NOT: fetch, read box scores, or know a league -- the
// caller passes its league's strict matcher and id parser. Strict-first because the lenient rule
// over full rosters makes teammates who share an initial and surname (Caleb / Chris Williams)
// ambiguous forever (spec audit P1-1: 29 of 2,138 NFL roster players, prod 2026-10-07).
import { matchPlayer } from './betting';

export const PROP_WAIT_REASONS = Object.freeze(['roster_unavailable', 'name_unresolved', 'name_ambiguous', 'team_total_mismatch']);

const validName = (s) => typeof s === 'string' && s.trim().length > 0;

export function resolvePropRosterId(roster, name, { strictMatches, parseId }) {
  if (!Array.isArray(roster)) return { wait: 'roster_unavailable' };
  if (!validName(name)) return { wait: 'name_unresolved' };
  const strict = strictMatches(roster, name);
  if (strict.unusable || strict.ids.size > 1) return { wait: 'name_ambiguous' };
  if (strict.ids.size === 1) return { id: strict.ids.values().next().value, lenient: false };
  const ids = new Set();
  for (const r of roster) {
    if (!validName(r?.player_name) || !matchPlayer(name, r.player_name)) continue;
    const id = parseId(r?.player_id);
    if (id == null) return { wait: 'name_ambiguous' }; // an unusable id could hide a namesake: fail closed
    ids.add(id);
  }
  if (ids.size === 0) return { wait: 'name_unresolved' };
  if (ids.size > 1) return { wait: 'name_ambiguous' };
  return { id: ids.values().next().value, lenient: true };
}
